import { initDependencies, setupDependencies } from './app';
import { runApp } from './services/runApp';
import { createContext } from './services/runApp/createContext';

setupDependencies();

const rawApplicationContext = initDependencies();

const applicationContext = createContext(rawApplicationContext);

runApp(applicationContext);

module.hot?.accept();
